<div class="wrapper-orders-mat" *ngIf="isLoaded">
  <div class="header-orders">
    <div class="wrapper-header-text">
      <div class="order-status">
        <p>
          <fa-icon [icon]="['fal','truck-moving']"></fa-icon>
          <span class="heading-2"> {{stateMaterials.inDelivery}} / {{stateMaterials.total}} matériaux en cours de livraison</span>
        </p>
        <span class="heading-2 separator">|</span>
        <p>
          <fa-icon [icon]="['fal','truck-moving']"></fa-icon>
          <span class="heading-2"> {{stateMaterials.delivered}} / {{stateMaterials.total}} matériaux livrés</span>
        </p>
      </div>
    </div>
  </div>
  <div class="wrapper-orders">
    <ng-container *ngFor="let room of projectRooms">
      <div class="card-rooms">
        <div class="header-card">
          <p class="localisation-room">
            <fa-icon [icon]="['fal','map-marker-alt']"></fa-icon>
            <span class="heading-3">{{room.label}}</span>
          </p>
          <p class="state-orders content-regular">
            {{calcMatDelivered(room.project_materials)}} / {{room.project_materials.length}} matériaux livrés
          </p>
        </div>
        <div class="wrapper-card-mat">
          <ng-container *ngFor="let mat of room.project_materials">
            <div class="content-mat">
              <div class="image-mat">
                <img [src]="mat.mainImg" alt="image-mat">
              </div>
              <div class="infos-mat">
                <p class="name-mat title-room">
                  {{mat._related.material_versions[0].name}}
                </p>
                <div class="status-order">
                  <span class="shopping-card-icon"  [ngClass]="{'has-state':mat.dates.effective_delivery || mat.dates.estimated_delivery}">
                     <fa-icon [icon]="['fal','shopping-cart']"></fa-icon>
                  </span>
                  <span *ngIf="!mat.state
                  || (mat.state === 'CMD' && !mat.dates.estimated_delivery)
                  || mat.state === 'BPA'
                  || mat.state === 'DD'" class="valid-or-order">
                    <span class="caption-2" *ngIf="!mat.state || mat.state === 'DD'"> Matériau Validé </span>
                    <span class="caption-2" *ngIf="((mat.state === 'CMD' && !mat.dates.estimated_delivery)
                                                    || mat.state === 'BPA')">Commande en cours</span>
                  </span>
                  <span *ngIf="mat.state && mat.dates.estimated_delivery && !mat.dates.effective_delivery" class="estimated-delivery">
                    <span class="icon-arrow"> <fa-icon [icon]="['fal','arrow-right']"></fa-icon>  </span>
                    <span> <fa-icon [icon]="['fal','truck-moving']"></fa-icon> </span>
                    <span class="caption-2"> Livraison estimé le {{mat.dates.estimated_delivery | date: 'dd-MM-yyyy'}} </span>
                  </span>
                  <span *ngIf="mat.state && mat.dates.effective_delivery" class="effective-delivery">
                    <span class="icon-arrow"> <fa-icon [icon]="['fal','arrow-right']"></fa-icon>  </span>
                    <span class="icon-truck"> <fa-icon [icon]="['fal','truck-moving']"></fa-icon> </span>
                    <span class="icon-arrow"> <fa-icon [icon]="['fal','arrow-right']"></fa-icon>  </span>
                    <span class="icon-check"> <fa-icon [icon]="['fal','check-square']"></fa-icon></span>
                    <span class="caption-2"> Livré au dépot </span>
                  </span>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </ng-container>
  </div>
</div>
